import { Status } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { buildStatus } from '../../factories';
import { canonicalStatuses } from '../../factories/seeds/entities';

export const mockStatuses: Status[] = canonicalStatuses.map(
  (status) => buildStatus<Status>(status) as Status
);

export const statusMockHandlers = [
  // mock for useListStatus()
  http.get('*/resource/status/all', () => {
    return HttpResponse.json(mockStatuses);
  }),
];
